import styled from 'styled-components';

export const SearchableDropdownWrapper = styled.div`
    .hb-dropdown__input {
        width: 100% !important;
    }

    input {
        width: 100% !important;
    }
`;
